module.exports = __webpack_public_path__ + "media/src/site/images/logo_min-9383451af7bcca999776750876d1bd46.svg";